import React from 'react';

function AchievementUnlockModal({ achievements, onClose }) {
  const list = Array.isArray(achievements) ? achievements.filter(Boolean) : [];
  if (!list.length) return null;

  const heading =
    list.length === 1 ? 'Achievement unlocked!' : `${list.length} achievements unlocked!`;

  return (
    <div className="achievement-modal-backdrop" onClick={onClose} role="presentation">
      <div
        className="achievement-modal achievement-unlock-modal"
        role="dialog"
        aria-labelledby="achievement-unlock-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="achievement-modal-close" onClick={onClose} aria-label="Close">
          ×
        </button>
        <p className="achievement-unlock-eyebrow">Nice work</p>
        <h3 id="achievement-unlock-title">{heading}</h3>
        <ul className="achievement-unlock-list">
          {list.map((achievement) => (
            <li key={achievement.id} className="achievement-unlock-item">
              <span className="achievement-modal-badge" aria-hidden="true">
                <span className="achievement-icon-large">{achievement.icon}</span>
              </span>
              <div>
                <strong>{achievement.name}</strong>
                <p className="achievement-modal-saying">“{achievement.saying}”</p>
                <p className="achievement-modal-description">{achievement.description}</p>
              </div>
            </li>
          ))}
        </ul>
        <button type="button" onClick={onClose}>
          Continue
        </button>
      </div>
    </div>
  );
}

export default AchievementUnlockModal;
